import axios from "axios";

export const API_ROOT = process.env.REACT_APP_CAUS_API_URL;
export const TOKEN_KEY = "caus_token";
export const USER_KEY = "caus_user";

const api = axios.create({ baseURL: `${API_ROOT}/api`, timeout: 45000 });

function attachAuth(instance) {
  instance.interceptors.request.use((config) => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  });
  instance.interceptors.response.use(
    (res) => res,
    async (err) => {
      const cfg = err.config || {};
      const retriable = !err.response && ["get", "put"].includes((cfg.method || "").toLowerCase());
      if (retriable && (cfg.__retries || 0) < 2) {
        cfg.__retries = (cfg.__retries || 0) + 1;
        await new Promise((r) => setTimeout(r, 1200));
        return instance(cfg);
      }
      if (err.response?.status === 401 && localStorage.getItem(TOKEN_KEY)) {
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(USER_KEY);
        window.location.href = "/login";
      }
      return Promise.reject(err);
    }
  );
}

attachAuth(api);

export const localApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, timeout: 120000 });
attachAuth(localApi);

export function apiError(err, fallback = "Ocurrió un error. Intenta de nuevo.") {
  const detail = err?.response?.data?.detail;
  if (detail == null) {
    return err?.response ? fallback : "Sin conexión con el servidor. Verifica tu internet e intenta de nuevo.";
  }
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((d) => (d && typeof d.msg === "string" ? d.msg : JSON.stringify(d))).join(" ");
  if (typeof detail === "object" && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export async function downloadFile(path, filename) {
  const res = await api.get(path, { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export default api;
